import axios from 'axios'
import store from '../store/index'

//let devBaseUrl = 'http://192.168.2.116:8099/horn/'
//let devBaseUrl = 'http://localhost:8089/horn/'
// let devBaseUrl = 'http://localhost:8089/horn/'
let devBaseUrl = 'https://www.hornlaw-firm.com/horn-api/'
//开发
 // let baseUrl = 'http://localhost:8080/horn/'
 //let baseUrl = 'http://47.104.65.112:8099/horn-api/'
//正式
let baseUrl = 'https://www.hornlaw-firm.com/horn-api/'
// let baseUrl = 'http://192.168.2.116/horn/'


let h = (url, isDev, type = 'post') => (params, cb) => {
    const tarUrl = url + (store.state.lang == 'en' ? '?lang=en' : '?lang=zh')
    return axios[type]((isDev ? devBaseUrl : baseUrl) + tarUrl, type == 'get' ? { params } : params).then(cb)
}

export default {
    cl: h('changelanauage'),
    homeData: h('home'),
    elite: h('elite'),
    detailDetail: h('elite/detail'),
    activity: h('activity'),
    activityDetail: h('activity/detail'),
    information: h('information'),
    informationDetail: h('information/detail'),
    cases: h('cases'),
    casesDetail: h('cases/detail'),
    customer: h('customer'),
    recruit: h('joinUs'),
    recruitDetail: h('joinUs/detail'),
    file: h('common/upload'),
    submit: h('recommendation'),
    sendEmail: h('sendEmail'),
}



// WEBPACK FOOTER //
// ./src/api/index.js